module.exports = __webpack_public_path__ + "static/media/windows_to_open.69f3c4b7.svg";